// import React from "react";
import { FiSend } from "react-icons/fi";
import React, { useState, useEffect, useContext } from 'react';
import { getSellerRevenueSummary } from '../../../../api/order/orderApi';
import { Container, Row, Col, Card, CardBody, Table } from 'reactstrap';
import { getOrderSummaryByBoatOwner } from '../../../../api/order/orderApi';
import { getMontlyRevenue } from '../../../../api/order/orderApi';
import { getOrdersByBoatOwner } from '../../../../api/order/orderApi';
import { getOrdersByCourierId } from '../../../../api/order/orderApi';
import { AuthContext } from '../../../ExtraPages/AuthProvider';
import axios from 'axios';
import {
  faShoppingCart,
  faRefresh,
  faRocket,
  faCreditCard,
  faSpaghettiMonsterFlying,
  faPiggyBank,
  faCodeCompare,
  faThermometerAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import DataTable from 'react-data-table-component';
import manChecking from '../../../../assets/images/man-checking.png';
import { motion } from 'framer-motion';
// Register the necessary Chart.js components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const NeumorphismButton = () => {
  const buttonStyle = {
    padding: '6px 16px',
    border: 'none',
    borderRadius: '50px',
    backgroundColor: '#E6F0FA', // Light blue
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#003366', // Dark blue
    transition: 'all 0.3s ease',
  };

  const hoverStyle = {
    backgroundColor: '#003366', // Dark blue
    color: '#E6F0FA', // Light blue for hover effect
  };

  const [isHovered, setHovered] = React.useState(false);

  return (
    <button
      style={isHovered ? { ...buttonStyle, ...hoverStyle } : buttonStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <FiSend />
      <span>Track</span>
    </button>
  );
};

const Overview = () => {
  const [revenueData2, setRevenueData] = useState([]);
  const [isHovered, setHovered] = useState(false);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [ordersSummary, setOrdersSummary] = useState({});
  const [comaparePercentage, setComparePercentage] = useState(0);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);
  const [monthlyRevenue, setMonthlyRevenue] = useState({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });

  const [orders, setOrders] = useState([]);

  // Set userId when user is available
  useEffect(() => {
    if (user && user.uid) {
      setUserId(user.uid);
    }
  }, [user]);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Monthly Revenue Line Chart',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Define columns
  const columns = [
    {
      name: 'Order Date',
      selector: (row) =>
        new Date(row.Order_Date).toISOString().slice(0, 19).replace('T', ' '),
      sortable: true,
      width: '180px',
    },
    {
      name: 'Product',
      selector: (row) => row.Product_Name,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row) =>
        row.Courier_Status === 'true'
          ? 'Accepted'
          : row.Courier_Status === 'false'
          ? 'Rejected'
          : 'Pending',
      cell: (row) => (
        <span
          className={`status-button-${
            row.Courier_Status === 'true'
              ? 'success'
              : row.Courier_Status === 'false'
              ? 'danger'
              : 'warning'
          }`}
        >
          {row.Courier_Status === 'true'
            ? 'Accepted'
            : row.Courier_Status === 'false'
            ? 'Rejected'
            : 'Pending'}
        </span>
      ),
    },
    {
      name: 'Quantity (kg)',
      selector: (row) => row.quantity || 'N/A',
      sortable: true,
      right: true,
    },
    {
      name: 'Courier Fee (LKR)',
      selector: (row) => row.Courier_Fee || 'N/A',
      sortable: true,
      right: true,
    },
    {
      name: 'Harbour',
      selector: (row) => row.Harbour || 'N/A',
      sortable: true,
    },
  ];
  useEffect(() => {
    if (!userId) return;

    const fetchRevenueData = async () => {
      setLoading(true);
      try {
        // Fetch orders for the courier
        const ordersResponse = await getOrdersByCourierId(userId);
        const ordersData = ordersResponse.data.data || [];
        setOrders(ordersData);

        // Calculate total orders
        const totalOrders = ordersData.length;

        // Calculate accepted orders
        const acceptedOrders = ordersData.filter(
          (order) => order.Courier_Status === 'true'
        ).length;

        // Calculate pending orders
        const pendingOrders = ordersData.filter(
          (order) =>
            order.Courier_Status !== 'true' && order.Courier_Status !== 'false'
        ).length;

        // Calculate total revenue from accepted orders with Courier_Fee
        const revenue = ordersData
          .filter(
            (order) => order.Courier_Status === 'true' && order.Courier_Fee
          )
          .reduce((sum, order) => sum + parseFloat(order.Courier_Fee || 0), 0);

        setTotalRevenue(revenue.toFixed(2));

        // Calculate average order value
        const avgOrderValue =
          acceptedOrders > 0 ? (revenue / acceptedOrders).toFixed(2) : 0;

        setOrdersSummary({
          totalOrders,
          acceptedOrders,
          pendingOrders,
          avgOrderValue,
        });

        // Calculate monthly revenue for chart
        const monthlyData = {};
        const currentYear = new Date().getFullYear();

        ordersData.forEach((order) => {
          if (
            order.Courier_Status === 'true' &&
            order.Courier_Fee &&
            order.Order_Date
          ) {
            const date = new Date(order.Order_Date);
            if (date.getFullYear() === currentYear) {
              const month = date.toLocaleString('default', { month: 'short' });
              monthlyData[month] =
                (monthlyData[month] || 0) + parseFloat(order.Courier_Fee || 0);
            }
          }
        });

        // Prepare chart data
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const revenueByMonth = months.map((month) => monthlyData[month] || 0);

        setMonthlyRevenue({
          labels: months,
          datasets: [
            {
              label: 'Monthly Courier Fee Revenue (LKR)',
              data: revenueByMonth,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 2,
              fill: true,
            },
          ],
        });

        // Calculate comparison percentage (compare current month vs last month)
        const currentMonth = new Date().getMonth();
        const currentMonthRevenue = revenueByMonth[currentMonth] || 0;
        const lastMonthRevenue = revenueByMonth[currentMonth - 1] || 0;

        if (lastMonthRevenue > 0) {
          const percentage =
            ((currentMonthRevenue - lastMonthRevenue) / lastMonthRevenue) * 100;
          setComparePercentage(percentage.toFixed(1));
        } else {
          setComparePercentage(0);
        }
      } catch (error) {
        console.error('Error fetching courier data:', error);
        setOrders([]);
        setOrdersSummary({
          totalOrders: 0,
          acceptedOrders: 0,
          pendingOrders: 0,
          avgOrderValue: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchRevenueData();
  }, [userId]);

  const revenueData = [
    { month: 'Jan', revenue: 3000 },
    { month: 'Feb', revenue: 4000 },
    { month: 'Mar', revenue: 3200 },
    { month: 'Apr', revenue: 4500 },
    { month: 'May', revenue: 5000 },
    { month: 'Jun', revenue: 6000 },
  ];

  const ongoingOrders = [
    { id: 1, product: 'Fish', status: 'Processing', quantity: 10 },
    { id: 2, product: 'Shrimp', status: 'Shipped', quantity: 15 },
    { id: 3, product: 'Crab', status: 'Processing', quantity: 8 },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }} // Initial state
      animate={{ opacity: 1, y: 0 }} // Animation when component mounts
      exit={{ opacity: 0, y: -20 }} // Exit animation
      transition={{ duration: 0.5 }} // Transition duration
    >
      {loading ? (
        <Container
          fluid
          className="mt-4"
        >
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <h5>Loading courier data...</h5>
          </div>
        </Container>
      ) : !user ? (
        <Container
          fluid
          className="mt-4"
        >
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <h5>Please log in to view courier overview.</h5>
          </div>
        </Container>
      ) : (
        <Container
          fluid
          className="mt-4"
        >
          <Row className="g-4">
            {/* Left Section - Revenue & Orders Overview */}
            <Col
              md={12}
              lg={8}
              sm={12}
            >
              <Row
                className="g-4 p-3 margin-right1"
                style={{
                  background: 'white',
                  borderRadius: '10px',
                }}
              >
                {[
                  {
                    title: 'Vs last month',
                    icon: faCodeCompare,
                    value: `${comaparePercentage}%`,
                    bg:
                      comaparePercentage > 0
                        ? 'bg-c-green'
                        : comaparePercentage === 0
                        ? 'bg-c-yellow'
                        : 'bg-c-pink',
                    background: '#8380FF',
                  },
                  {
                    title: 'Total Orders',
                    icon: faShoppingCart,
                    value: ordersSummary.totalOrders,
                    bg: 'bg-c-blue',
                    background: '#00A991',
                  },
                  {
                    title: 'Average Order Value',
                    icon: faPiggyBank,
                    value: `LKR ${ordersSummary.avgOrderValue || 0}`,
                    bg: 'bg-c-blue',
                    background: '#003B8F',
                  },
                ].map(({ title, icon, value, bg, background }, index) => (
                  <Col
                    sm={12}
                    lg={4}
                    md={12}
                    key={index}
                  >
                    <div
                      className={
                        title != 'Average Order Value' ? `border-right1` : ''
                      }
                    >
                      <div>
                        <div
                          className="m-b-20"
                          style={{ color: 'black' }}
                        >
                          <FontAwesomeIcon
                            icon={icon}
                            className="f-left"
                            style={{
                              fontSize: '1.2rem',
                              borderRadius: '40px',
                              background: background,
                              padding: '10px',
                              color: 'white',
                            }}
                          />
                          <div style={{ position: 'relative', left: '20px' }}>
                            <div className="text-black">{title}</div>
                            <div>
                              <h3>{value}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>

              {/* Monthly Revenue Chart */}
              <Row
                className="g-4 margin-right1"
                style={{ marginTop: '0px' }}
              >
                <div
                  style={{
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '10px',
                  }}
                >
                  <h5>Revenue Insights</h5>
                  <Line
                    data={monthlyRevenue}
                    options={options}
                  />
                </div>
              </Row>
            </Col>

            {/* Right Section - Revenue & Orders Summary */}
            <Col
              lg={4}
              md={12}
              sm={12}
              className="g-4 p-4 margin-zero"
              style={{ background: 'white', borderRadius: '10px' }}
            >
              <h4>Revenue & Orders</h4>
              <hr />
              <span className="text-gray">Your total revenue is</span>
              <h1>LKR {totalRevenue}</h1>
              <span className="text-black">
                {new Date().toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  weekday: 'long',
                })}
              </span>
              <hr />
              <span className="text-black">Total Accepted Orders</span>{' '}
              <span className="text-black">
                <b>{ordersSummary.acceptedOrders || 0} orders</b>
              </span>
              <hr />
              <span className="text-black">Pending Orders</span>{' '}
              <span className="text-black">
                <b>{ordersSummary.pendingOrders || 0} orders</b>
              </span>
              <img
                src={manChecking}
                style={{ paddingTop: '40px', display: 'block', width: '50%' }}
              />
            </Col>
          </Row>

          {/* Ongoing Orders Table */}
          <Row
            className="g-4"
            style={{ marginTop: '0px' }}
          >
            <div
              style={{
                backgroundColor: '#fff',
                padding: '20px',
                borderRadius: '10px',
                overflowX: 'auto',
              }}
            >
              <h5>Ongoing Orders</h5>
              <DataTable
                columns={columns}
                data={orders}
                pagination
              />
            </div>
          </Row>
        </Container>
      )}
    </motion.div>
  );
};

export default Overview;
